import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { LeaderboardCategory } from '@/types/leaderboard';

interface CategoryTabsProps {
  selected: LeaderboardCategory;
  onSelect: (category: LeaderboardCategory) => void;
}

const TABS: { key: LeaderboardCategory; label: string }[] = [
  { key: 'check_ins', label: 'Check-ins This Week' },
  { key: 'reviews', label: 'Reviews This Week' },
];

export function CategoryTabs({ selected, onSelect }: CategoryTabsProps) {
  return (
    <Tabs value={selected} onValueChange={(v) => onSelect(v as LeaderboardCategory)}>
      <TabsList className="px-4">
        {TABS.map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key} title={tab.label} />
        ))}
      </TabsList>
    </Tabs>
  );
}
